import React from 'react';

import './styles.css';

const PageMap = ({ data, content, changePage }) => {
    const buttonStyles = {
        download: { backgroundImage: `url(${content.button_icon_download})` },
        share: { backgroundImage: `url(${content.button_icon_share})` },
        scroll: { backgroundImage: `url(${content.button_icon_scroll})` },
    };

    return (
        <section id='ncs-page-map'>
            <div className='ncs-section-content'>
                <div className='ncs-highlight-container'>
                    <div className='highlight-top-divider' />
                    <div>
                        <h3 className='title'>Ilhas</h3>
                        <p>
                            Para aprender a navegar com segurança pelos mares do
                            mundo digital vamos desembarcar em 5 ilhas
                            diferentes. Cada uma delas tem informações
                            importantes para que pais, mães e responsáveis
                            possam se apropriar desse assunto e saber como
                            mediar a relação dos filhos e filhas com a
                            tecnologia.
                        </p>
                        <button
                            className='ncs-island-button'
                            onClick={() => changePage(1)}
                        >
                            <img src={data[1].icon} alt={data[1].island} />
                            <span>
                                Na ilha{' '}
                                <strong>Sociedade & Digitalização</strong>,
                                trazemos reflexões sobre os desafios de uma
                                sociedade cada vez mais digital, entendendo que
                                o tempo conectado, as formas de conexão e as
                                experiências online não são iguais para todas as
                                pessoas.
                            </span>
                        </button>
                        <button
                            className='ncs-island-button'
                            onClick={() => changePage(2)}
                        >
                            <img src={data[2].icon} alt={data[2].island} />
                            <span>
                                Na ilha <strong>Cotidiano & Tecnologia</strong>,
                                entendemos que a internet veio para ficar, e
                                trazemos informações valiosas para organizar
                                melhor o espaço que ela ocupa no nosso dia a
                                dia.
                            </span>
                        </button>
                        <button
                            className='ncs-island-button'
                            onClick={() => changePage(3)}
                        >
                            <img src={data[3].icon} alt={data[3].island} />
                            <span>
                                Na ilha <strong>Perigos, Riscos & Danos</strong>
                                , vamos olhar o “mundo virtual” como parte do
                                mundo real e, dessa forma, aprender sobre alguns
                                dos seus perigos. Entender os riscos é
                                fundamental para tomarmos atitudes preventivas!
                            </span>
                        </button>
                        <button
                            className='ncs-island-button'
                            onClick={() => changePage(4)}
                        >
                            <img src={data[4].icon} alt={data[4].island} />
                            <span>
                                Na ilha{' '}
                                <strong>Sexualidade & Violências</strong>,
                                apresentaremos as diferentes formas de violência
                                sexual online para que possam acompanhar e
                                orientar as crianças e os adolescentes,
                                prevenindo que cometam crimes ou que sejam
                                vítimas de abuso e a exploração sexual.
                            </span>
                        </button>
                        <button
                            className='ncs-island-button'
                            onClick={() => changePage(5)}
                        >
                            <img src={data[5].icon} alt={data[5].island} />
                            <span>
                                Por fim, na ilha{' '}
                                <strong>Mediação Parental</strong>, trazemos
                                ferramentas para pais, mães e responsáveis
                                contribuírem com a navegação segura, ética e
                                respeitosa de crianças e adolescentes na
                                internet. Lembrando que o problema não está na
                                tecnologia, mas sim no uso que fazemos dela.
                            </span>
                        </button>
                        <p>
                            Com essa jornada, esperamos poder contribuir para a
                            proteção de crianças e adolescentes no mundo
                            digital!
                        </p>
                    </div>
                    <div className='highlight-bottom-divider' />
                </div>
            </div>
            <div className='ncs-social-buttons-container'>
                <button
                    className='btn-download'
                    style={buttonStyles.download}
                />
                <button className='btn-share' style={buttonStyles.share} />
            </div>
            <div className='ncs-scroll-button-container'>
                <button className='btn-scroll' style={buttonStyles.scroll} />
            </div>
        </section>
    );
};

export default PageMap;
